module.exports = __webpack_public_path__ + "img/exclamation-mark-icon.66621ebc.svg";